<div class="alert alert-success" i18n>Your report was sent successfully.</div>
<h1 class="report-headline" i18n>Thank you for submitting your report.</h1>
<h2 class="report-headline-2" i18n>Category:</h2>
<p>{{category?.value}}</p>
<h2 class="report-headline-2" i18n>Reason:</h2>
<p>{{reason}}</p>
<h2 class="report-headline-2" i18n>Contact option:</h2>
<p *ngIf="allowContact" i18n>We might contact you, if we have further questions about your report.</p>
<p *ngIf="!allowContact" i18n="report no contact wanted|report no contact wanted">We won't contact you about your report.</p>
